export default {
  PARTNERS_MODULE: 'partners',
  CAMPAIGNS_MODULE: 'campaigns',
  CAMPAIGN_SETTING_MODULE: 'campaignSetting',
  CAMPAIGN_DID_MODULE: 'campaigndid',
  CALLPATHS_MODULE: 'callPaths',
  PROMPTS_MODULE: 'prompts',
  DID_TYPE_SINGLE: 'single',
  IKNOWMYDID: 'iknowmydid',
  MID_NIGHT: 1439, // 11.59 PM
  FULL_DAY: 1440, // 24 hours
  ADMIN_PROMPT_TYPE_ID: 13,//Admin Prompt Type
  subscriptionFilterTypeChannelID: 40,
  subscriptionFilterTypeClientID: 41,
  transferPromptData: [
    { transferPromptId: 1, transferPromptName: 'Enable Client Name' },
    { transferPromptId: 0, transferPromptName: 'Default Transfer Prompt' },
    { transferPromptId: 2, transferPromptName: 'Disable Transfer Prompt' }
  ],
  pingTranferTypeData: [
    { pingTransferTypeId: 0, pingTransferTypeName: 'Direct Transfer only' },
    { pingTransferTypeId: 1, pingTransferTypeName: 'Warm Transfer only' },
    { pingTransferTypeId: 2, pingTransferTypeName: 'Both Direct and Warm Transfer' },
    //skipping 3 due to mapping enum to None in backend
    { pingTransferTypeId: 4, pingTransferTypeName: 'Conciege only' },
    { pingTransferTypeId: 5, pingTransferTypeName: 'IVR only' },
  ],
  categoryDetails: [
    { categoryID: 1, categoryName: 'Holiday' },
    { categoryID: 2, categoryName: 'DirectMail' },
    { categoryID: 3, categoryName: 'Partner' },
    { categoryID: 4, categoryName: 'Campaign' },
    { categoryID: 5, categoryName: 'Prompt' },
    { categoryID: 6, categoryName: 'CallPath' },
    { categoryID: 7, categoryName: 'Filter' },
    { categoryID: 8, categoryName: 'Blocked Numbers' },
    { categoryID: 9, categoryName: 'User Role' },

  ],
  holidayScheduleDetails: {
    holidayScheduleCreate: `New Holiday $(date) Created`,
    holidayScheduleDate: `HolidayDate from $(oldDate) to $(newDate)`,
    holidayScheduleNotes: `HolidayNotes from $(oldNotes) to $(newNotes)`,
    holidayScheduleDelete: `Holiday $(id) deleted`,
  },
  supportDetails: {
    supportDetailsCreate: `New Support $(field) Created`
  },
  UniqueKeyPropertyList: ['partnerAffiliateInvitationID', 'campaignAttributeFilterId', 'ScheduleId', 'IntervalCapsId', 'affiliateTypeID', 'campaignStateBidPriceId',
    'categoricalValueID', 'promptLogicIndex', 'callPathPromptID', 'campaignFilterID', 'dayPartIndex', 'intervalCapId', 'affiliateCampaignSettingID', 'campaignsPhoneNumberId', 'callPathPromptConnectionID', 'pressSayIndex', 'suppressedName'],
  OmissionPropertyList: {
    "Partner": ['partnerID', 'associatedCampaigns', 'partnerAffiliateInvitationID', 'campaignCount', 'dateInvitationSent', 'billingContactFirstName',
      'billingContactLastName', 'billingContactEmailAddress', 'billingContactAddress1', 'billingContactAddress2', 'billingContactPhoneNumber',
      'billingContactCity', 'billingContactZipCode', 'billingContactState', 'isBillingChecked', 'affiliateEmailAddress', 'affiliateFirstname', 'affiliateLastname',
      'AffiliateEmailStatus'],
    "Filter": ['filterTypeVariantID', 'categoricalValueID', 'categoryIndex', 'categorical', 'filterTypeOperatorFormat', 'filterTypeOperatorID',
      'numerical', 'leadTypeName', 'subscriptionFilterTypesToRolesModelList'],
    "DirectMail": ['campaignID', 'campaignCategoryID', 'directMailID', 'campaignPhoneNumber', 'dids'],
    "User Role": ['statusId', 'userToRoleId', 'keyIndex'],
    "Holiday": ['holidayId', 'keyIndex'],
    "Blocked Numbers": ['callNumberID', 'keyIndex', 'isRowDataModified', 'oldNotes', 'oldPhoneNumber', 'spinner', 'tazClientAuditLog', 'numberType'],
    "Prompt": ['duration', 'promptID', 'promptTypeID', 'subscriptionFilterTypeID', 'promptConnectionID', 'promptParameterID', 'pressSayIndex', 'keyIndex',
      'promptLogicIndex', 'promptParameterID', 'logicTypeID', 'callPathID', 'press', 'say', 'parameterName', 'parameterValue'],
    "CallPath": ['callPathID', 'callPathPromptID', 'connectingPromptID', 'transferPromptId', 'whisper', 'callPathRow', 'duration', 'promptScript',
      'promptTypeID', 'promptVoice', 'subscriptionFilterInput', 'subscriptionFilterType', 'subscriptionFilterTypeID', 'subscriptionFilterTypeName',
      'callPathPromptConnectionID', 'promptConnectionID', 'promptID', 'promptTypeName', 'PromptNameFrom', 'PromptNameTo', 'promptName', 'callPathColumn', 'press', 'say'],
    "common": ['createdBy', 'createdDate', 'updatedBy', 'utccreatedDate', 'utcmodifiedDate', 'ptcreatedDate', 'ptmodifiedDate', 'statusID',
      'utcCreatedDate', 'utcModifiedDate', 'ptCreatedDate', 'ptModifiedDate', 'modifiedBy', 'lastModifiedDate', 'keyIndex', 'configurationID'],
    "Campaign": ['campaignId', 'partnerId', 'campaignCallTypeID', 'campaignFilterID', 'scheduleCapID', 'intervalCapID', 'dayOfWeek', 'dayPartItemIndex', 'isBidValid', 'isEnabled',
      'isStateValid', 'campaignStateBidPriceId', 'affiliateTypeID', 'statusId', 'areaCode', 'friendlyName', 'campaignbidpriceid', 'filterTypeOperatorID',
      'accountID', 'isValidFilterType', 'checked', 'pageNumber', 'DayPartId', 'subscriptionID', 'campaignSourceTypeID', 'didcalculationType',
      'numberOfImpression', 'numberOfImpressionType', 'averageTimeSession', 'averageTimeSessionType', 'stateBidId', 'pingTransferType',
      'affiliateCampaignSettingID', 'index', 'campaignsPhoneNumberId', 'subscriptionFilterTypeID', 'selectedFilterNameList', 'accountID', 'accountName',
      'accountStatus', 'clientID', 'channelName', 'clientQuoteTypeID', 'subscriptionName', 'subscriptionStatus', 'isCheckedChannel', 'isCheckedClient', 'subscriptionFilterTypeName',
      'DailyScheduleId', 'affiliateCampaignSettingJson', 'campaignsPhoneNumberJson', 'campaignStateBidPricesJson', 'suppressedQuestionsJson', 'didsCount', 'volume', 'isAffiliate', 'filterInput', 'suppressedName', 'status', 'IntervalDayId', 'DailyIntervalId', 'filterType', 'capCounter',
      'bid', 'enabled', 'state', 'DaysWithoutCalls', 'startMinute', 'endMinute', 'scheduleCapID', 'capLimit', 'concurrencyCap', 'dayPartIndex',
      'CampaignFilterTypeInputValue', 'FilterTypeOperator', 'FilterType', 'FilterInput', 'filterName']
  },
  ContextPropertyInclusionList: [], //'affiliateEmailAddress', 'localCategoryValue', 'parameterName', 'parameterValue','promptName', 'affiliateTypeName','state','dayOfWeek','PromptNameTo', 'PromptNameFrom', 'press', 'say','filterName', 'bid', 'enabled', 'startMinute', 'endMinute', 'capLimit', 'concurrencyCap', 'AffiliateEmailStatus', 'suppressedName','capCounter'],
  ParentUniqueIDs: ['partnerId', 'directMailID', 'holidayId', 'userToRoleId', 'subscriptionFilterTypeID', 'callNumberID', 'callPathID', 'campaignId', 'subscriptionID', 'CallAttributeID', 'ScheduleID', 'AssignCallPathID', 'subscriptionFilterTypeId'],
  ContextInclusionChilList: [],
  DependentProperty: ['campaignsPhoneNumber', 'campaignStateBidPrices', 'promptConnectionModels', 'promptParameters', 'callPathPrompt', 'callPathPromptConnection', 'Scheduler', 'IntervalCaps', 'CallAttributes'],
  partnerPageToolTip: {
    isAffiliate: "Affiliate toggle set to ON indicates a partner or vendor we are purchasing calls from. Affiliate toggle should be set to OFF if we are not purchasing calls from this partner or vendor",
    addAffiliateEmailAddress: "If you add an Affiliate Email Address, you are granting the specified third-party user(s) access to the Taz platform where they will be able to access Affiliate Reporting for their partner name",
    isHoliday: "When Holiday Schedule is selected, calls will not connect to the associated campaign(s) during the Holiday dates listed on the Taz Holiday Schedule page"
  },
  campaignPageToolTip: {
    bidMargin: "Bid Margin% must be between -50% and 99%. Max bid is configurable by vertical",
    bidFloor: "Bid Floor must be between 1 and 999.",
    bidCeiling: "Bid Ceiling must be between 1 and 999.",
    marginThreshold: "Margin Threshold % is required at between -50% and 99%",
    noDial: "if Yes, a 'NoDial' message will be sent to five9"
  },
  displaySuppressedQuestionId: {
    PingPostStaticId: 3,
    PingPostDynamicId: 4,
    pingTransferTypeId: 0,
    fullPostRevshareId: 5
  },
  affiliateTypes: [
    { affiliateTypeID: 1, typeName: "Rev Share" },
    { affiliateTypeID: 2, typeName: "Static Price" },
    { affiliateTypeID: 3, typeName: "Ping Post - Static" },
    { affiliateTypeID: 4, typeName: "Ping Post - Dynamic" },
    { affiliateTypeID: 5, typeName: "FullPost RevShare" },
    { affiliateTypeID: 6, typeName: "Ping - Dynamic" },
    { affiliateTypeID: 7, typeName: "FullPing - Dynamic" },
  ],
  accountType: [
    "Agent",
    "Corporate"
  ],
  reportStartDatetime: ' 00:00:00',
  reportEndDatetime: ' 23:59:59',
  callDispositionDisplayName: [
    { key: 'NoBuyerAvailable-', value: 'NoBuyerAvailable' },
    { key: 'NotQualified-', value: 'NotQualified' },
    { key: 'Transferred-', value: 'Transferred' },
  ]
};
